import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logic|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

export type SPCatalogCertLogicLocNames =
	| 'SPCatalogCertLogicTitleTab'
	| 'SPCatalogCertLogicTitleSection'
	| 'SPCatalogCertLogicContentLogicNotApproved'
	| 'SPCatalogCertLogicLabelLogic'
	| 'SPCatalogCertLogicLabelVersion'
	| 'SPCatalogCertLogicContentInitialRequirement'
	| 'SPCatalogCertLogicContentExtension'	
	| 'SPCatalogCertLogicContentCurrent'
	| 'SPCatalogCertLogicContentSuspendedRequirement';

export const spCatalogCertLogicLocs: LocDefs<SPCatalogCertLogicLocNames> = {
	SPCatalogCertLogicTitleTab: {
		defaultValue: 'Credential Logic',
		description: 'Tab title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.Logic.Title.TabTitle',
		...sharedProperties,
	},
	SPCatalogCertLogicTitleSection: {
		defaultValue: 'Logic',
		description: 'Section title',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.Logic.Title.SectionTitle',
		...sharedProperties,
	},
	SPCatalogCertLogicContentLogicNotApproved: {
		defaultValue: 'Selected logic version is not yet approved',
		description: 'Not approved logic text',
		displayPath: `${pathStart}Not approved logic`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logic.Content.LogicNotApproved',
		...sharedProperties,
	},
	SPCatalogCertLogicLabelLogic: {
		defaultValue: 'Logic',
		description: 'Label for: Logic.',
		displayPath: `${pathStart}Logic`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Logic.FieldLabel.Logic',
		...sharedProperties,
	},
	SPCatalogCertLogicLabelVersion: {
		defaultValue: 'Version',
		description: 'Label for: Version.',
		displayPath: `${pathStart}Version`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Logic.FieldLabel.Version',
		...sharedProperties,
	},
	SPCatalogCertLogicContentInitialRequirement: {
		defaultValue: 'Initial Requirement',
		description: 'Version option: Initial Requirement.',
		displayPath: `${pathStart}Initial Requirement`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logic.MenuItem.InitialRequirement',
		...sharedProperties,
	},
	SPCatalogCertLogicContentExtension: {
		defaultValue: 'Extension (Re-certification)',
		description: 'Version option: Extension (Re-certification).',
		displayPath: `${pathStart}Extension (Re-certification)`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logic.MenuItem.Extension',
		...sharedProperties,
	},	
	SPCatalogCertLogicContentCurrent: {
		defaultValue: 'Current',
		description: 'Current version option.',
		displayPath: `${pathStart}Current`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logic.MenuItem.Current',
		...sharedProperties,
	},
	SPCatalogCertLogicContentSuspendedRequirement: {
		defaultValue: 'Suspended Requirement',
		description: 'Version option: Suspended Requirement.',
		displayPath: `${pathStart}Suspended Requirement`,
		displayType: 'Content',
		...sharedProperties,
	},
};

export type SPCatalogCertLogicLocType = LocMap<SPCatalogCertLogicLocNames>;
